__webpack_require__.p = "/bizx-smart/shan-auto/";